import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { path } from 'ramda';
import Table from '../../сomponents/Table';
import Breadcrumbs from '../../common/Breadcrumbs';
import ConfirmAction from '../../common/ConfirmAction';
import { changeModalState } from '../../actions/modal';
import { deleteObject } from '../../actions/objectToDelete';
import { fetchAllEmailTemplates, deleteEmailTemplateById } from '../../api/emailTemplate';
import './style.css';
import Preloader from "../../common/Preloader";
import hasAccess from "../../helpers/permissionChecker";

export class EmailTemplates extends Component {

  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
    this.handlerDelete = this.handlerDelete.bind(this);
    this.handlerEdit = this.handlerEdit.bind(this);
    this.addEmailTemplate = this.addEmailTemplate.bind(this);
    this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);

    this.state = {
      items: Array.from([]),
      container: false,
      search: '',
      itemsPerPage: 10,
      loading: true,
      currentPage: 0,
    };

    this.columns = [
      'id',
      'name',
      'created',

    ];

    this.columnNames = [
      'Id',
      'Name',
      'Created',
    ];
  }

  addEmailTemplate() {
    this.props.moveToAdd();
  }

  onSearch(e) {
    e.preventDefault();
    this.setState({
      search: e.target.value,
    });
    return false;
  }

  onChangeItemsPerPage(e) {
    e.preventDefault();
    this.setState({
      itemsPerPage: e.target.value,
    });
    return false;
  }

  onChangeCurrentPage(currentPage) {
    this.setState({
      currentPage: currentPage,
    });
  }

  componentDidUpdate() {
    const itemsList = path(['emailTemplate', 'list'], this.props);
    const { loading } = this.state;
    if (loading && itemsList) {
      this.setState({ loading: false });
    }
  }

  componentWillMount() {
    this.props.loadTemplates();
  }

  handlerDelete(id) {
    this.props.handleObjectToDelete({
      id: parseInt(id),
      handler: deleteEmailTemplateById,
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'deleteEmailTemplateById',
    });
  }

  handlerEdit(id) {
    this.props.moveToEdit(id);
  }

  render() {
    const itemsList = path(['emailTemplate', 'list'], this.props);
    const itemActions = {
      edit: {
        handler: this.handlerEdit,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-pencil icon-stack-1x'],
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'edit',
      },

      delete: {
        handler: this.handlerDelete,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-times icon-stack-1x'],
        permission: { 'permAreaKey': 'emailTemplate', 'permTypeKey': 'delete' },
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'delete',
      }
    };

    const { loading } = this.state;
    const mainPart = loading ? <Preloader show={true} type='circle'/> :
      <Table
        items={itemsList}
        columns={this.columns}
        columnNames={this.columnNames}
        itemsPerPage={this.state.itemsPerPage}
        search={this.state.search}
        currentPage={this.state.currentPage}
        onChangeCurrentPage={this.onChangeCurrentPage}
        actions={itemActions}
        onSearch={this.onSearch}
        onChangeItemsPerPage={this.onChangeItemsPerPage}
      />;
    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { icon: 'email', name: 'Email Templates' },
        ]}/>
        <div className="card rounded">
          <div className="card-header rounded-top">
            Email Templates
          </div>
          <div className="card-block">
            {hasAccess({ 'permAreaKey': 'emailTemplate', 'permTypeKey': 'create' }) &&
            <div className="clearfix mb-3">
              <button className="btn btn-rounded btn-icon ui-btn pull-right" onClick={this.addEmailTemplate}>
                <i className="material-icons">add_circle_outline</i>
                <span className="color-default">Add</span>
              </button>
            </div>
            }
            {mainPart}
            <ConfirmAction id={'deleteEmailTemplateById'}/>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadTemplates: () => fetchAllEmailTemplates()(dispatch),
    moveToEdit: (id) => {
      dispatch(push('/pages/email-template-edit/' + id));
    },
    moveToDelete: () => {
      dispatch(push('/pages/job-cards-delete'));
    },
    moveToAdd: () => {
      dispatch(push('/pages/email-template-add'));
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    handleObjectToDelete: (data) => {
      dispatch(deleteObject(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailTemplates);



// WEBPACK FOOTER //
// ./src/containers/EmailTemplates/index.js